import React from "react";
import Modal from "../../../../elements/Modal";
import ManageBlogs from "../ManageBlogs";

const ManageBlogsModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl2" title={"Create New "}>
      <ManageBlogs getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageBlogsModal;
